import * as moment from 'moment';
import { comparators } from '../core/comparators';
import { isEmpty } from 'lodash';

export function dateTimeComparator(date1: string, date2: string) {
    return comparators.dateTimeComparator(date1, date2);
}

export function dateTimeArrayComparator(date1: moment.Moment[], date2: moment.Moment[]) {
    const dateA = isEmpty(date1) ? null : date1[0];
    const dateB = isEmpty(date2) ? null : date2[0];
    return comparators.dateTimeComparator(dateA, dateB);
}